// Shared runtime config for the andAbout Hotels landing page.
export const WHATSAPP_NUMBER_DISPLAY = "+66 (0)62 229 8070";
// International format for wa.me links (no +, no spaces, no leading 0 after country code)
export const WHATSAPP_URL =
  "https://wa.me/66622298070?text=" +
  encodeURIComponent("Hi andAbout, I'd like to claim my business on the platform.");
